import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';

export function RouteErrorPage() {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : 500;

  return (
    <main className="grid min-h-screen place-items-center p-6">
      <div className="max-w-lg text-center">
        <p className="text-brand-600 text-sm font-bold tracking-widest uppercase">Error {status}</p>
        <h1 className="mt-3 text-3xl font-bold">This page could not be loaded</h1>
        <p className="mt-3 text-[var(--app-muted)]">
          Try again, or return home if the problem continues.
        </p>
        <Link
          to="/"
          className="bg-brand-600 hover:bg-brand-700 mt-6 inline-flex rounded-lg px-5 py-3 font-semibold text-white transition"
        >
          Return home
        </Link>
      </div>
    </main>
  );
}
